import React, { useEffect, useState } from "react";
import { ToyCycleLogo } from "./Logo";

const SPLASH_KEY = "toycycle_splash_seen";
const SPLASH_DURATION_MS = 1400;

/**
 * One-time-per-session splash. Shows the brand logo at hero size with the
 * recycle arrow spinning, then fades out. Skipped entirely if the user has
 * `prefers-reduced-motion` set or has already seen it this session.
 */
export const SplashScreen = () => {
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return false;
    return sessionStorage.getItem(SPLASH_KEY) !== "1";
  });
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!visible) return undefined;
    const fadeT = setTimeout(() => setFading(true), SPLASH_DURATION_MS - 350);
    const doneT = setTimeout(() => {
      sessionStorage.setItem(SPLASH_KEY, "1");
      setVisible(false);
    }, SPLASH_DURATION_MS);
    return () => { clearTimeout(fadeT); clearTimeout(doneT); };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`toycycle-splash fixed inset-0 z-[100] flex items-center justify-center bg-[#FDFBF7] transition-opacity duration-300 ${fading ? "opacity-0" : "opacity-100"}`}
      aria-hidden="true"
    >
      <div className="flex flex-col items-center gap-4 toycycle-splash-pop">
        <ToyCycleLogo size={140} />
        <span
          className="font-black text-3xl tracking-tight"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          <span className="text-gray-900">Toy</span>
          <span className="text-[#FF6B6B]">Cycle</span>
          <span className="text-[#4A90E2]">Hub</span>
        </span>
      </div>
    </div>
  );
};
